import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import { fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import TextArea from "../shared/TextArea";
import SelectDropdown from "../shared/SelectDropdown";

const NotesCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [notetypeData, setNotetypeData] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    notetype: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) {
      navigate("/");
    }
  }, [navigate]);

  // Fetch dropdown data
  const fetchAllData = async () => {
    const formDataReq = new FormData();
    formDataReq.append("userId", userId);
    formDataReq.append("moduleId", M_id);

    const res = await fetchFormData("notetype/getAllDrop", formDataReq, "POST");
    if (res && res.data) {
      const options = getValueLabel(res.data, "typename", "id").map((opt) => ({
        value: String(opt.value),
        label: opt.label,
      }));
      setNotetypeData(options);
    }
  };

  // Fetch details in edit mode
  const fetchDetails = async (noteId) => {
    const formDataReq = new FormData();
    formDataReq.append("id", noteId);
    formDataReq.append("userId", userId);

    const res = await fetchFormData("note/getById", formDataReq, "POST");
    if (res && res.data) {
      setFormData({
        title: res.data.title || "",
        description: res.data.description || "",
        notetype: String(res.data.notetype) || "",
      });
    }
  };

  useEffect(() => {
    const fetchDataAsync = async () => {
      await fetchAllData();
      if (id) {
        await fetchDetails(id);
      }
    };
    fetchDataAsync();
  }, [id]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleNoteTypeChange = (selectedOption) => {
    if (selectedOption) {
      setFormData((prev) => ({
        ...prev,
        notetype: selectedOption.value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formPayload = new FormData();
      formPayload.append("title", formData.title);
      formPayload.append("description", formData.description);
      formPayload.append("notetype", formData.notetype);
      formPayload.append("status", 1);
      formPayload.append("branchID", 1);
      formPayload.append("added_by", 1);
      formPayload.append("created_by", userId);
      formPayload.append("moduleId", M_id);
      let res;
      if (id) {
        formPayload.append("id", id);
        formPayload.append("userId", userId);
        res = await fetchFormData("note/update", formPayload, "POST");
      } else {
        res = await fetchFormData("note/insert", formPayload, "POST");
      }

      if (res && (res.code === 200 || res.code === 201)) {
        topTost({ title: res.message, icon: "success" });
        navigate(`/master/notes-list?id=${M_id}`);
      } else if (res && res.code === 422) {
        topTost({ title: res.message[{}], icon: "error" });
      } else {
        topTost({ title: res.message || "Operation failed", icon: "error" });
      }
    } catch (error) {
      console.error("Submit error:", error);
      topTost({ title: "Submission failed", icon: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  const selectedNoteTypeOption =
    notetypeData.find((opt) => opt.value === formData.notetype) || null;

  return (
    <div className="col-lg-12">
      <div className="card stretch stretch-full">
        <hr className="mt-0" />
        <div className="card-body general-info">
          <div className="mb-5 d-flex align-items-center justify-content-between">
            <h5 className="fw-bold mb-0 me-4">
              <span className="d-block mb-2">
                {id ? "Edit Notes:" : "Add Notes:"}
              </span>
            </h5>
          </div>

          <form onSubmit={handleSubmit} className="row g-3">
            <div className="row">
              <div className="col-md-6">
                <Input
                  label="Title Name"
                  name="title"
                  value={formData.title}
                  onChange={(name, value) => handleChange(name, value)}
                  placeholder="Title Name"
                  icon="feather-hash"
                  required
                />
              </div>
              <div className="col-lg-2 mt-2">
                <label className="fw-semibold">
                  Note type: <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-lg-4">
                <SelectDropdown
                  options={notetypeData}
                  selectedOption={
                    notetypeData.find(
                      (opt) => opt.value === formData.notetype
                    ) || null
                  }
                  value={formData.notetype}
                  onSelectOption={handleNoteTypeChange}
                  placeholder="Select Note type"
                  icon="feather-map-pin"
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <TextArea
                  label={
                    <>
                      Notes Description<span className="text-danger">*</span>
                    </>
                  }
                  name="description"
                  value={formData.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                  placeholder="Description"
                  icon="feather-type"
                  required
                />
              </div>
            </div>

            <div className="customButton">
              <button
                type="submit"
                className="btn btn-lg btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NotesCreate;
